module.exports = __webpack_public_path__ + "img/list8.c8a477be.png";